const getters = {
  userListGetter: state => state.userList.data,
  userStatusPending: state => state.userList.status.pending
};

export default getters;
